import React, {Component} from 'react'
import './App.css'
import StreetView from "./Components/StreetView"

class App extends Component {
  render() {
    return (
      <StreetView/>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js